import {
    addToChainBefore,
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { AddCartLinesApiParameter, addLineCollection } from "@insite/client-framework/Services/CartService";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { DispatchBeginUpdatingCart, chain } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddLinesToCart";
import { CartLineCollectionModel } from "@insite/client-framework/Types/ApiModels";
import setShowRequisitionCartDisclaimer from "@tKgpco/Handlers/RequistionCart/Handlers/showRequisitionCartDisclaimer";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        apiParameter: AddCartLinesApiParameter;
        onSuccess?: () => void;
    },
    AddCartLinesApiParameter,
    CartLineCollectionModel
>;

export const DispatchBeginUpdatingCartCustom: HandlerType = props => {
    const state = props.getState() as CustomApplicationState;

    if (state.KGPState.RequistionCartStore.isRequistionCartPresent) {
        props.dispatch(setShowRequisitionCartDisclaimer({ showDisclaimerForRequistionCart: true }));
        return false;
    }
};

addToChainBefore(chain, DispatchBeginUpdatingCart, DispatchBeginUpdatingCartCustom);
